import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import Bowser from 'bowser';
import config from 'lib/config';
import { EventType, SourcePages, Features, ImpressionType } from 'lib/EventSchema';
import LeadTrackingParams from 'types/Apis/LeadTrackingParams';
import { getFirebaseUid, getEventAuthLevel, getEventAuthProviders } from 'lib/Auth';
import Store from './Store';

// Eventually it would be nice to make this a real interface
// based on event schemas
export type EventContext = Record<string, any>;

export interface VdpEventContext {
  // eslint-disable-next-line camelcase
  tracking_params?: LeadTrackingParams;
}

export interface VdpEventData {
  // eslint-disable-next-line camelcase
  event_context?: VdpEventContext;
}

export interface SrpEventContext {
  // eslint-disable-next-line camelcase
  tracking_params?: LeadTrackingParams;
}

export interface SrpEventData {
  // eslint-disable-next-line camelcase
  event_context?: SrpEventContext;
}

interface UserData {
  // eslint-disable-next-line camelcase
  user_guid: string | null;
  // eslint-disable-next-line camelcase
  auth_level?: string;
  // eslint-disable-next-line camelcase
  auth_providers?: string[];
}

interface AbTestingData {
  // eslint-disable-next-line camelcase
  content_upsell_signup: boolean | null;
}
export interface EventData {
  /* eslint-disable camelcase */
  ata_client_id?: string;
  user_id?: number;
  event_context?: EventContext;
  event_type: EventType;
  engagement_type?: string;
  app_event_type?: string;
  view_type?: string;
  source_page?: SourcePages;
  feature?: Features;
  // new events ontology impression type field
  impression_type?: ImpressionType;
  // legacy type field required for now
  type?: ImpressionType;
  vin?: string;
  api_type?: string;
  /* eslint-enable camelcase */
}

type EventJSON = {
  // eslint-disable-next-line camelcase
  ab_testing: AbTestingData | null;
  platform: string;
  // eslint-disable-next-line camelcase
  client_guid: string;
  // eslint-disable-next-line camelcase
  device_category: string;
  // eslint-disable-next-line camelcase
  event_guid: string;
  // eslint-disable-next-line camelcase
  event_version: number;
  // eslint-disable-next-line camelcase
  session_guid: string;
  // eslint-disable-next-line camelcase
  sequence_number: number;
  timestamp: string;
  // eslint-disable-next-line camelcase
  app_name: string;
  // eslint-disable-next-line camelcase
  app_version: string;
  // eslint-disable-next-line camelcase
  device_user_agent: string;
  // eslint-disable-next-line camelcase
  cookie_user_agent: string | null;
} & EventData &
  UserData;

function getEdgeUserAgent(): string | undefined {
  const edgeCookie = Cookies.get('ec');

  if (edgeCookie) {
    return JSON.parse(Buffer.from(edgeCookie, 'base64').toString('utf8')).edgeUserAgent;
  }
  return undefined;
}

function getTimeStamp(): string {
  return new Date().toISOString();
}

interface Config {
  data: EventData;
  store: Store;
}

const APP_NAME = 'autolist-web';

export default class Event {
  data: EventData;

  store: Store;

  constructor({ data, store }: Config) {
    this.data = data;
    this.store = store;
  }

  toJSON(): EventJSON {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return {
      ab_testing: null,
      platform: 'web',
      event_guid: uuidv4(),
      event_version: 0,
      session_guid: this.store.getSessionGuid(),
      sequence_number: this.store.getSequenceNumber(),
      timestamp: getTimeStamp(),
      app_name: APP_NAME,
      app_version: config.imageTag,
      device_user_agent: browser.getUA(),
      cookie_user_agent: getEdgeUserAgent() || null,
      device_category: browser.getPlatformType(),
      client_guid: this.store.getClientGuid(),
      user_guid: getFirebaseUid() || null,
      auth_level: getEventAuthLevel(),
      auth_providers: getEventAuthProviders(),
      ...this.data,
    };
  }
}
